import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { Message } from 'semantic-ui-react';
import { searchContent, resetSearchContent } from '@plone/volto/actions';
import { flattenToAppURL } from '@plone/volto/helpers';
import { contentFolderHasItems } from 'iovisit-theme/helpers';
import { Icon } from 'iovisit-theme/components';

const Body = ({ data, properties, isEditMode }) => {
  const { folder_name = 'materiale-scaricabile', title } = data;
  const dispatch = useDispatch();

  const content = properties;
  const url = content?.['@id']
    ? `${flattenToAppURL(content['@id'])}/${folder_name}`
    : null;

  const searchResults = useSelector((state) => state.search.subrequests);
  const hasChildren = contentFolderHasItems(content, folder_name);

  useEffect(() => {
    if (hasChildren && url) {
      dispatch(
        searchContent(
          url,
          {
            'path.depth': 1,
            sort_on: 'getObjPositionInParent',
            metadata_fields: '_all',
            fullobjects: 1,
          },
          folder_name,
        ),
      );
    }
    return () => {
      dispatch(resetSearchContent(folder_name));
    };
  }, [dispatch, folder_name, hasChildren, url]);

  const attachments = searchResults?.[folder_name]?.items || [];
  let files = attachments.filter((item) => item['@type'] === 'File');

  return !hasChildren || files.length === 0 ? (
    isEditMode ? (
      <Message size="mini">
        Materiali scaricabili: Nessun file da mostrare nella cartella 'Materiale
        Scaricabile'.
        <br />
        Questo blocco non verrà mostrato in visualizzazione.
      </Message>
    ) : null
  ) : (
    <div className="block list-download-file">
      {title && <h2>{title}</h2>}
      {files.length > 0 && (
        <ul className="list">
          {files.map((file) => {
            return (
              <li>
                <Icon prefix="far" icon="file-alt" className="icon" />
                <a
                  href={flattenToAppURL(file.file.download)}
                  title={file.title}
                  download
                >
                  {file.title}
                </a>
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
};
export default Body;
